document.addEventListener("DOMContentLoaded", function () {
    if (window.AnnouncementSliderEnabled) {
      let slider = document.getElementById(`announcement-slider-${window.AnnouncementSectionId}`);
      if (slider) {
        new Splide(slider, {
          type: 'loop',
          perPage: 1,
          autoplay: true,
          interval: window.AnnouncementBarTime * 1000,
          direction: 'ttb',
          height: '50px',
          pagination: false,
          arrows: false
        }).mount();
      }
    }
  });
  